<div class="workflow-advance-container" [ngClass]="{ 'ml-2': onAppReqPanel }">
    <button class="workflow-advance in-contact btn btn-primary" [class]="!(visible$ | async) || disabled  ? 'submit-disabled' : ''" (click)="sendToFundingDesk()">
        Submit App
    </button>
</div>
